import React from 'react';
import { Tabs, type TabsProps } from 'antd';
import { TabWrapper } from '../styled';

const DashboardTypesTabs = ({ items, onChange, tabBarExtraContent }: TabsProps) => {
  return (
    <TabWrapper>
      <Tabs items={items} onChange={onChange} tabBarExtraContent={tabBarExtraContent} />
    </TabWrapper>
  );
};

export default DashboardTypesTabs;
